var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<a role=\"tab\" data-toggle=\"tab\" class=\"btn-tab btn-tab-editable\">\n  <span class=\"title\"></span>\n</a>";
},"useData":true});